import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const manuscript = new Restful(project, 'manuscript')

manuscript.step1 = function(data) {
  const url = project + 'manuscript/step1'
  return http.post(url, data).then(res => {
    return res
  })
}
manuscript.step2 = function(data) {
  const url = project + 'manuscript/step2'
  return http.post(url, data).then(res => {
    return res
  })
}
manuscript.step3 = function(data) {
  const url = project + 'manuscript/step3'
  return http.post(url, data).then(res => {
    return res
  })
}
manuscript.step4 = function(data) {
  const url = project + 'manuscript/step4'
  return http.post(url, data).then(res => {
    return res
  })
}
manuscript.step5 = function(data) {
  const url = project + 'manuscript/step5'
  return http.post(url, data).then(res => {
    return res
  })
}
manuscript.author = function(data) {
  const url = project + 'manuscript/author'
  return http.get(url, data).then(res => {
    return res
  })
}
manuscript.authorLogin = function(id) {
  const url = project + 'manuscript/author/login/' + id
  return http.get(url).then(res => {
    return res
  })
}
manuscript.authorCount = function(data) {
  const url = project + 'manuscript/author/count'
  return http.get(url, data).then(res => {
    return res
  })
}
manuscript.revision = function(data) {
  const url = project + 'manuscript/author/revision'
  return http.post(url, data).then(res => {
    return res
  })
}
// 作者查看所有的报告
manuscript.allReport = function(manuscriptId, data) {
  const url = project + `manuscript/author/all/review_report/${manuscriptId}`
  return http.get(url, data).then(res => {
    return res
  })
}
manuscript.ftype = function(data) {
  const url = project + 'manuscript/ftype'
  return http.get(url, data).then(res => {
    return res
  })
}

manuscript.status = function(data) {
  const url = project + 'manuscript/status'
  return http.get(url, data).then(res => {
    return res
  })
}

manuscript.replace = function(data) {
  const url = project + 'manuscript/replace'
  return http.get(url, data).then(res => {
    return res
  })
}
// 期刊基本信息
manuscript.info = function(id, type, data) {
  const url = project + 'manuscript/' + id + '/' + type
  return http.get(url, data).then(res => {
    return res
  })
}

// 发票
manuscript.getInvoice = function(id, data) {
  const url = project + 'manuscript/' + id + '/invoice'
  return http.get(url, data).then(res => {
    return res
  })
}
manuscript.addInvoice = function(id, data) {
  const url = project + 'manuscript/' + id + '/invoice'
  return http.post(url, data).then(res => {
    return res
  })
}
manuscript.certificate = function(id, data) {
  const url = project + `manuscript/reviewer/certificate_code/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}
manuscript.locked = function(id, locked, data) {
  const url = project + `manuscript/locked/${id}/${locked}`
  return http.put(url, data).then(res => {
    return res
  })
}

const editorAssign = new Restful(project, 'editor/assigned')

const authorReviewReport = new Restful(
  project,
  'manuscript/author/review_report'
)

export { manuscript, editorAssign, authorReviewReport }
export default manuscript
